import { FunctionComponent } from "react";
import { Outlet } from "react-router-dom";

import { ErrorPageType, PermissionRoles } from "@/enum";
import { useIsFeatureActive } from "@/utils/useIsFeatureActive";
import { useHasPermissions } from "@/utils/useHasPermissions";

import { FeaturesCodes } from "@/pages/Private/pages/Users/enum/codes";

import { ErrorPage } from "../ErrorPage/ErrorPage";
import { LoadingOverlay } from "../LoadingOverlay/LoadingOverlay";

interface FeatureRouteProps {
	feature?: FeaturesCodes;
	permission?: PermissionRoles;
	companyIds?: number[];
	companyId?: number;
}

export const FeatureRoute: FunctionComponent<FeatureRouteProps> = ({
	feature,
	permission,
	companyIds,
	companyId,
}) => {
	const isFeatureActive = useIsFeatureActive(feature ?? "");
	const { hasPermissions } = useHasPermissions();

	if (isFeatureActive === undefined) {
		return <LoadingOverlay />;
	}

	if (feature && isFeatureActive === false) {
		return <ErrorPage type={ErrorPageType.Forbidden} />;
	}

	if (permission && !hasPermissions([permission])) {
		return <ErrorPage type={ErrorPageType.Forbidden} />;
	}

	if (companyIds && companyId && !companyIds.includes(companyId)) {
		return <ErrorPage type={ErrorPageType.Forbidden} />;
	}

	return <Outlet />;
};
